export const changeStatusDevice = (array, itemToChange) => {
  if (array.some(item => item.id === itemToChange.id)) {
    const newData = array.map(item =>
      item.id === itemToChange.id
        ? {
            ...item,
            connectionStatus: itemToChange.connectionStatus,
          }
        : item
    );

    return newData;
  }
};
